import type { TypedSupabaseClient } from '../client';

/**
 * Résout la composante « année » des numéros générés pour le tenant courant.
 *
 * company_settings.doc_number_include_year :
 *  - true (défaut)  → retourne l'année demandée → numéros {PREFIX}-{YEAR}-{NNNN}
 *  - false          → retourne null             → numéros {PREFIX}-{NNNN}
 *    (tenants qui continuent la numérotation de leur ancien système, ex. TuniElec)
 *
 * Partagé par tous les générateurs hors ventes (paiements, caisse, stock,
 * RAS, storefront) ; sales-repository lit le même flag via son
 * resolveNumberingContext() qui charge déjà company_settings.
 */
export async function resolveDocNumberYear(
  supabase: TypedSupabaseClient,
  year: number = new Date().getFullYear(),
): Promise<number | null> {
  // current_user_tenant_id + colonne pas encore dans les types générés →
  // même pattern de cast que les autres repositories.
  type SbAny = {
    rpc: (fn: string, args: Record<string, unknown>) => Promise<{ data: string | null; error: { message: string } | null }>;
  };
  const { data: tenantId } = await (supabase as unknown as SbAny).rpc('current_user_tenant_id', {});
  if (!tenantId) return year;
  const { data } = await supabase
    .from('company_settings')
    .select('*')
    .eq('tenant_id', tenantId)
    .maybeSingle();
  const includeYear = ((data ?? {}) as Record<string, unknown>)['doc_number_include_year'];
  return includeYear === false ? null : year;
}
